import { render, staticRenderFns } from "./PatientCustomerDataForm.vue?vue&type=template&id=6cb5f12e&scoped=true&"
import script from "./PatientCustomerDataForm.vue?vue&type=script&lang=js&"
export * from "./PatientCustomerDataForm.vue?vue&type=script&lang=js&"
import style0 from "./PatientCustomerDataForm.vue?vue&type=style&index=0&id=6cb5f12e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb5f12e",
  null
  
)

export default component.exports